import { LAGO_PLAN_MAP } from './lagoPlanMap';

const LAGO_ADDON_MAP: Record<string, string> = {
  'Fitness-l1-USD-Every-3-months': 'fitness-bl-m3-usd',
  'Fitness-l1d-USD-Every-3-months': 'fitness-bl-disc-m3-usd',

  'Fitness_2-USD-Weekly': 'fitness-email-w1-usd',
  'Fitness_3-USD-Weekly': 'fitness-email-disc-w1-usd',

  'Fitness-e2-USD-Every-12-weeks': 'fitness-us-bl-w12-usd',
  'Fitness-e2d-USD-Every-12-weeks': 'fitness-us-bl-disc-w12-usd',

  'Fitness-l1-USD-Every-12-weeks': 'fitness-bl-w12-usd',
  'Fitness-l1d-USD-Every-12-weeks': 'fitness-bl-disc-w12-usd',

  // Sexology courses
  'sexology_1-USD': 'sexology-bl-lifetime-usd',
  'sexology_2-USD': 'sexology-bl-disc-lifetime-usd',
};

type AddonCodes = { standard: string; disc: string };

type AddonFamily = {
  byPlan: Record<string, AddonCodes>;
  fallback: AddonCodes;
};

type PlanScopedAddon = { family: AddonFamily; isDisc: boolean };

const FITNESS_BL_W1M1: AddonCodes = {
  standard: 'fitness-bl-w1m1-usd',
  disc: 'fitness-bl-disc-w1m1-usd',
};

const FITNESS_BL_M1: AddonCodes = {
  standard: 'fitness-bl-m1-usd',
  disc: 'fitness-bl-disc-m1-usd',
};

const FITNESS_US_W1W4: AddonCodes = {
  standard: 'fitness-us-bl-w1w4-usd',
  disc: 'fitness-us-bl-disc-w1w4-usd',
};

const FITNESS_US_W4: AddonCodes = {
  standard: 'fitness-us-bl-w4-usd',
  disc: 'fitness-us-bl-disc-w4-usd',
};

const FITNESS_US_W12: AddonCodes = {
  standard: 'fitness-us-bl-w12-usd',
  disc: 'fitness-us-bl-disc-w12-usd',
};

const FITNESS_WW_W1W4: AddonCodes = {
  standard: 'fitness-bl-w1w4-usd',
  disc: 'fitness-bl-disc-w1w4-usd',
};

const FITNESS_WW_W4: AddonCodes = {
  standard: 'fitness-bl-w4-usd',
  disc: 'fitness-bl-disc-w4-usd',
};

const FITNESS_BL_MONTHLY: AddonFamily = {
  byPlan: {
    'kegel-bl-w1m1-usd': FITNESS_BL_W1M1,
    'kegel-bl-disc-w1m1-usd': FITNESS_BL_W1M1,
    'kegel-pw2-699-3499-w1m1-usd': FITNESS_BL_W1M1,
    'kegel-pw2-699-3999-w1m1-usd': FITNESS_BL_W1M1,
    'kegel-pw2-699-1999-w1m1-usd': FITNESS_BL_W1M1,
    'kegel-bl-m1-usd': FITNESS_BL_M1,
    'kegel-bl-disc-m1-usd': FITNESS_BL_M1,
  },
  fallback: FITNESS_BL_M1,
};

const FITNESS_US_4WEEK: AddonFamily = {
  byPlan: {
    'kegel-us-bl-w1w4-usd': FITNESS_US_W1W4,
    'kegel-pw2-999-3499-w1w4-usd': FITNESS_US_W1W4,
    'kegel-pw2-999-3999-w1w4-usd': FITNESS_US_W1W4,
    'kegel-pw2-1399-5999-w1w4-usd': FITNESS_US_W1W4,
    'kegel-us-bl-w4-usd': FITNESS_US_W4,
    'kegel-us-bl-disc-w4-usd': FITNESS_US_W4,
  },
  fallback: FITNESS_US_W4,
};

const FITNESS_US_12WEEK: AddonFamily = {
  byPlan: {
    'kegel-us-bl-w12-usd': FITNESS_US_W12,
    'kegel-us-bl-disc-w12-usd': FITNESS_US_W12,
  },
  fallback: FITNESS_US_W12,
};

const FITNESS_WW_4WEEK: AddonFamily = {
  byPlan: {
    'kegel-us-bl-w1w4-usd': FITNESS_WW_W1W4,
    'kegel-pw2-999-3499-w1w4-usd': FITNESS_WW_W1W4,
    'kegel-pw2-999-3999-w1w4-usd': FITNESS_WW_W1W4,
    'kegel-pw2-1399-5999-w1w4-usd': FITNESS_WW_W1W4,
    'kegel-us-bl-w4-usd': FITNESS_WW_W4,
    'kegel-us-bl-disc-w4-usd': FITNESS_WW_W4,
  },
  fallback: FITNESS_WW_W4,
};

const PLAN_SCOPED_FITNESS: Record<string, PlanScopedAddon> = {
  'Fitness-l1-USD-Monthly': { family: FITNESS_BL_MONTHLY, isDisc: false },
  'Fitness-l1d-USD-Monthly': { family: FITNESS_BL_MONTHLY, isDisc: true },
  'Fitness-e2-USD-Every-4-weeks': { family: FITNESS_US_4WEEK, isDisc: false },
  'Fitness-e2d-USD-Every-4-weeks': { family: FITNESS_US_4WEEK, isDisc: true },
  'Fitness-l1-USD-Every-4-weeks': { family: FITNESS_WW_4WEEK, isDisc: false },
  'Fitness-l1d-USD-Every-4-weeks': { family: FITNESS_WW_4WEEK, isDisc: true },
  'Fitness-t1-USD-Every-4-weeks': { family: FITNESS_US_4WEEK, isDisc: true },
  'Fitness-t1-USD-Every-12-weeks': { family: FITNESS_US_12WEEK, isDisc: true },
};

const PLAN_SCOPED_UPSELLS: Record<string, Record<string, string>> = {
  'Sexology-t1-USD-Every-4-weeks': {
    'kegel-us-bl-w1w4-usd': 'sexology-upsell-test-w1w4-usd',
    'kegel-us-bl-w4-usd': 'sexology-upsell-test-w4-usd',
    'kegel-us-bl-disc-w4-usd': 'sexology-upsell-test-w4-usd',
  },
  'Meditations-t1-USD-Every-4-weeks': {
    'kegel-us-bl-w1w4-usd': 'meditation-upsell-test-w1w4-usd',
    'kegel-us-bl-w4-usd': 'meditation-upsell-test-w4-usd',
    'kegel-us-bl-disc-w4-usd': 'meditation-upsell-test-w4-usd',
  },
  'Sexology-t1-USD-Every-12-weeks': {
    'kegel-us-bl-w12-usd': 'sexology-upsell-test-w12-usd',
    'kegel-us-bl-disc-w12-usd': 'sexology-upsell-test-w12-usd',
  },
  'Meditations-t1-USD-Every-12-weeks': {
    'kegel-us-bl-w12-usd': 'meditation-upsell-test-w12-usd',
    'kegel-us-bl-disc-w12-usd': 'meditation-upsell-test-w12-usd',
  },
};

export function resolveLagoAddonCode(item?: string, basePlanId?: string): string | undefined {
  if (!item) return item;
  if (!basePlanId) return LAGO_ADDON_MAP[item] ?? item;

  const lagoPlanCode = LAGO_PLAN_MAP[basePlanId] ?? basePlanId;

  const fitness = PLAN_SCOPED_FITNESS[item];
  if (fitness) {
    const codes = fitness.family.byPlan[lagoPlanCode] ?? fitness.family.fallback;

    return fitness.isDisc ? codes.disc : codes.standard;
  }

  const upsellCode = PLAN_SCOPED_UPSELLS[item]?.[lagoPlanCode];
  if (upsellCode) return upsellCode;

  return LAGO_ADDON_MAP[item] ?? item;
}
